import { AfterContentChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { firstValueFrom, Subscription } from 'rxjs'
import { ProfileStateService } from 'src/app/evida/profile/services/profile-state.service'
import { AdminService } from 'src/app/evida/services/admin-service'
import { AuthService } from '../../auth/auth.service'
import { Menu, MenuItemId, SubmenuItem } from '../../models/menu.model'
import { MenuService } from '../../services/menu.service'

@Component({
    selector: 'app-vertical-menu',
    templateUrl: './vertical-menu.component.html',
    styleUrls: ['./vertical-menu.component.scss'],
    standalone: false,
})
export class VerticalMenuComponent implements AfterContentChecked, OnInit {
    @Input() public burgerMenu = false
    @Output() public navigateToRoute = new EventEmitter<string>()

    public accessRequestCount = 0

    private subscriptions = new Subscription()

    constructor(
        public menuService: MenuService,
        private changeDetectorRef: ChangeDetectorRef,
        private profileStateService: ProfileStateService,
        private adminService: AdminService,
        private authService: AuthService
    ) {}

    public ngOnInit(): void {
        this.subscriptions.add(
            this.profileStateService.customerNumber$.subscribe(async (customerNumber) => {
                await this.updateAccessRequestCount(customerNumber)
            })
        )

        this.adminService.onAccessRequestsUpdated(async () => {
            await this.updateAccessRequestCount(null)
        })
    }

    private async updateAccessRequestCount(customerNumber: string | null) {
        customerNumber = customerNumber ?? (await firstValueFrom(this.profileStateService.customerNumber$))

        if (customerNumber) {
            const accessRequests = await firstValueFrom(this.adminService.getAccessRequest$(customerNumber))
            this.accessRequestCount = accessRequests?.length ?? 0
        }
    }

    public ngAfterContentChecked() {
        this.changeDetectorRef.detectChanges()
    }

    public onMenuClick(menuItem: Menu) {
        this.menuService.menuItemSelected(menuItem)
        this.navigateTo(menuItem.routerLink)
    }

    public onSubmenuClick(menuItem: SubmenuItem) {
        this.menuService.submenuItemSelected(menuItem)
        this.navigateTo(menuItem.routerLink)
    }

    public shouldDisplayRequestCount(menuItem: SubmenuItem) {
        return menuItem.id === MenuItemId.admin && this.accessRequestCount > 0 && this.authService.isBusinessCustomer
    }

    private navigateTo(routerLink: string) {
        if (routerLink) {
            this.navigateToRoute.emit(routerLink)
        }
    }
}
